<template>
  <li>
    <router-link :to="{ name: 'newsDetail', params: { id: item.id }}">
      <time>{{ formatDate(item.date) }}</time>
      <p>{{ item.title }}</p>
    </router-link>
  </li>
</template>

<script>
import { formatDate } from '@/utils/date'

export default {
  name: 'NewsListItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDate,
  },
}
</script>
